"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _masthead = _interopRequireDefault(require("@amzn/meridian-tokens/component/masthead"));

var _theme = require("../theme");

var _focus = _interopRequireDefault(require("../_focus"));

var _clickable = _interopRequireDefault(require("../_clickable"));

var _token = require("./../_utils/token");

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(t, _ref) {
  var focus = _ref.focus;
  return (0, _emotion.css)({
    display: "block",
    borderRadius: 4,
    paddingInlineStart: t("spacingHorizontal"),
    "& img": {
      display: "block"
    }
  }, (0, _focusRing["default"])(t.tokens, {
    offset: 4,
    borderRadius: 4,
    focus: focus
  }));
};
/**
 * This component can be used to render a logo/title lockup. Place this as a
 * child of the Masthead component.
 */


var MastheadTitle = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MastheadTitle, _React$Component);

  var _super = _createSuper(MastheadTitle);

  function MastheadTitle() {
    (0, _classCallCheck2["default"])(this, MastheadTitle);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MastheadTitle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          onClick = _this$props.onClick,
          children = _this$props.children,
          rel = _this$props.rel,
          target = _this$props.target;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _masthead["default"],
        map: (0, _token.getTokenHelper)("masthead")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref2) {
          var focus = _ref2.focus,
              focusProps = _ref2.focusProps,
              focusTrigger = _ref2.focusTrigger;
          return /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: styles(t, {
              focus: focus && focusTrigger === "keyboard"
            }),
            href: href,
            onClick: onClick,
            rel: rel,
            target: target
          }), children);
        });
      });
    }
  }]);
  return MastheadTitle;
}(_react["default"].Component);

MastheadTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the title (e.g. the application name or logo image).
   */
  children: _propTypes["default"].node.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,

  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,

  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,

  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,

  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func
} : {};
var _default = MastheadTitle;
exports["default"] = _default;